import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import CardUser from "./CardUser"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
  Input
} from "reactstrap"
import { Link } from "react-router-dom"



// Pages Components
import WelcomeComp from "./WelcomeComp"
import ReportCount from "./ReportCount"

import { getReportDashboard } from "store/group/dashboard/actions"

import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const series = [
  {
    name: "Current",
    data: [18, 21, 45, 36, 65, 47, 51, 32, 40, 28, 31, 26],
  },
  {
    name: "Previous",
    data: [30, 11, 22, 18, 32, 23, 58, 45, 30, 36, 15, 34],
  },
]



class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reports: [
       /* { title: "Branch Count", iconClass: "bx-copy-alt", description: "2" },
        {
          title: "User Count",
          iconClass: "bx-archive-in",
          description: "2",
        },*/
        {
          title: "Ai Report Counts",
          iconClass: "bx-purchase-tag-alt",
          description: "129",
        },
      ],
      
    }
  }
  componentDidMount() {
    const { onGetReportDashboardCount } = this.props
    onGetReportDashboardCount()
  }

  
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="" breadcrumbItem="Dashboard" />
            <Row>
            <Col xl="4">
                <WelcomeComp />

              </Col>
              <Col xl="8">
                <Row>
                  {/* Reports Render */}
                  {this.state.reports.map((report, key) => (
                    <Col md="4" key={"_col_" + key}>
                      <Card className="mini-stats-wid">
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{this.props.reportCount.totalCount}</h4>
                            </div>
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                              <span className="avatar-title">
                                <i
                                  className={
                                    "bx " + report.iconClass + " font-size-24"
                                  }
                                />
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
                </Col>
             {/* <Col xl="8">
              <CardUser cardreport={this.state.cardreport} />

    </Col>*/}
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}


Dashboard.propTypes = {
  reportCount : PropTypes.object,
  onGetReportDashboardCount: PropTypes.func,
}

const mapStateToProps = ({ grpDashboard }) => ({
  reportCount : grpDashboard.reportDashboardData,

})

const mapDispatchToProps = dispatch => ({
  onGetReportDashboardCount: () => dispatch(getReportDashboard()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Dashboard))